import { IYearMonth } from '@/coreDomainsModule/date';
import { PutSupplierForecastResponsibleUserIdRequest } from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';

/**
 * update apiで使用するデータをUI用と変換する
 */
export class BulkUpdateAdapter {
  /**
   * 仕入先内示の編集APIのリクエストデータに変換
   * @param aggregateBusinessIds - 集計取引ID
   * @param staffIds - 担当者IDリスト
   */
  public static adaptForRequest = (aggregateBusinessIds: string[], staffIds: string[]): PutSupplierForecastResponsibleUserIdRequest => {
    return {
      targetAggregateBusinessIdList: aggregateBusinessIds,
      aggregateBusinessUserIdList: staffIds,
    };
  };
}
